'use es6';

import DefaultIllustrationNames from 'feedback-schema/constants/illustrations/thankYou';
import * as SurveyTypes from 'feedback-schema/constants/surveyTypes';
import { makeSafeInnerHTML } from 'feedback-utils/sanitize';
import EmailAddressRegex from 'PatternValidationJS/patterns/EmailAddress';
import { Component } from 'react';
import { NavMarker } from 'react-rhumb';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Image } from 'foundations-components/transitional/components/Image';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { LegalConsentOptions, Selectors } from '../../Constants';
import ImagePage from '../ImagePage';
import SubmitButton from '../SubmitButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ThankYou extends Component {
  constructor(props) {
    super(props);
    this.renderSubmitButton = this.renderSubmitButton.bind(this);
    this.state = {
      communicationConsentIsChecked: false,
      email: null,
      explicitProcessingConsentIsChecked: false
    };
  }
  isSubmitEnabled() {
    const {
      props: {
        config: {
          gdprSettings
        }
      }
    } = this;
    const gdprConsentType = gdprSettings && gdprSettings.gdprConsentType;
    const {
      email,
      explicitProcessingConsentIsChecked
    } = this.state;
    if (!email || !EmailAddressRegex.test(email)) {
      return false;
    }
    return !gdprConsentType || gdprConsentType !== LegalConsentOptions.SEPARATE_CONSENT || explicitProcessingConsentIsChecked;
  }
  maybeRenderGDPRDetails(shouldShowGDPRConsent, gdprSettings, submitButtonLabel) {
    if (!shouldShowGDPRConsent) {
      return null;
    }
    const {
      communicationConsentCheckboxLabel,
      communicationConsentText,
      explicitProcessingConsentCheckboxLabel,
      explicitProcessingConsentText,
      gdprConsentType,
      implicitProcessingConsentText,
      legitimateInterestPrivacyPolicyText,
      privacyPolicyText
    } = gdprSettings;
    return /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "500",
      paddingBlock: "400",
      paddingInline: "200",
      inlineSize: "100%",
      children: [(gdprConsentType === LegalConsentOptions.IMPLICIT_CONSENT || gdprConsentType === LegalConsentOptions.SEPARATE_CONSENT) && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "small",
          marginBlockStart: "400",
          dangerouslySetHTML: makeSafeInnerHTML(communicationConsentText)
        }), /*#__PURE__*/_jsx(Checkbox, {
          checked: this.state.communicationConsentIsChecked,
          onChange: ({
            target: {
              checked
            }
          }) => {
            this.setState({
              communicationConsentIsChecked: checked
            });
          },
          size: "small",
          marginBlock: "200",
          children: /*#__PURE__*/_jsx("span", {
            dangerouslySetInnerHTML: makeSafeInnerHTML(communicationConsentCheckboxLabel)
          })
        })]
      }), gdprConsentType === LegalConsentOptions.SEPARATE_CONSENT && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "small",
          marginBlockStart: "400",
          dangerouslySetHTML: makeSafeInnerHTML(explicitProcessingConsentText)
        }), /*#__PURE__*/_jsx(Checkbox, {
          checked: this.state.explicitProcessingConsentIsChecked,
          onChange: ({
            target: {
              checked
            }
          }) => {
            this.setState({
              explicitProcessingConsentIsChecked: checked
            });
          },
          size: "small",
          marginBlock: "200",
          children: /*#__PURE__*/_jsx("span", {
            dangerouslySetInnerHTML: makeSafeInnerHTML(explicitProcessingConsentCheckboxLabel)
          })
        })]
      }), (gdprConsentType === LegalConsentOptions.IMPLICIT_CONSENT || gdprConsentType === LegalConsentOptions.SEPARATE_CONSENT) && /*#__PURE__*/_jsx(Text, {
        as: "small",
        marginBlockStart: "400",
        dangerouslySetHTML: makeSafeInnerHTML(privacyPolicyText)
      }), gdprConsentType === LegalConsentOptions.IMPLICIT_CONSENT && /*#__PURE__*/_jsx(Text, {
        as: "small",
        marginBlockStart: "400",
        dangerouslySetInnerHTML: makeSafeInnerHTML(implicitProcessingConsentText)
      }), gdprConsentType === LegalConsentOptions.LEGITIMATE_INTEREST && /*#__PURE__*/_jsx(Text, {
        as: "small",
        marginBlockStart: "400",
        dangerouslySetInnerHTML: makeSafeInnerHTML(legitimateInterestPrivacyPolicyText)
      }), gdprConsentType !== LegalConsentOptions.NONE && this.renderSubmitButton(submitButtonLabel)]
    });
  }
  renderSubmitButton(submitButtonLabel) {
    const {
      communicationConsentIsChecked,
      email
    } = this.state;
    const {
      config: {
        themeColor
      }
    } = this.props;
    return /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      display: "block",
      children: /*#__PURE__*/_jsx(SubmitButton, {
        disabled: !this.isSubmitEnabled(),
        onClick: () => this.props.onSubmitClick(email, communicationConsentIsChecked),
        themeColor: themeColor,
        children: submitButtonLabel
      })
    });
  }
  render() {
    const {
      onClose,
      onImageLoad,
      respondentType,
      webRespondent: {
        hasEmail
      },
      config: {
        closeLabel,
        gdprSettings,
        surveyType,
        thankYou: {
          bodies: {
            [respondentType.toLowerCase()]: body
          },
          headers: {
            [respondentType.toLowerCase()]: heading
          },
          images: {
            [respondentType.toLowerCase()]: imageConfig
          }
        },
        submitLabel: submitButtonLabel
      }
    } = this.props;
    const shouldShowGDPRConsent = !hasEmail && surveyType === SurveyTypes.CSAT && gdprSettings && gdprSettings.gdprConsentType !== LegalConsentOptions.NONE && gdprSettings.privacyPolicyText;
    return /*#__PURE__*/_jsx(ImagePage, {
      content: this.maybeRenderGDPRDetails(shouldShowGDPRConsent, gdprSettings, submitButtonLabel),
      image: imageConfig.hasImage && (imageConfig.imageUrl ? /*#__PURE__*/_jsx(Image, {
        src: imageConfig.imageUrl,
        onLoad: onImageLoad,
        alt: "thank you image"
      }) : /*#__PURE__*/_jsx(Illustration, {
        onLoad: onImageLoad,
        alt: DefaultIllustrationNames[respondentType],
        name: DefaultIllustrationNames[respondentType]
      })),
      children: /*#__PURE__*/_jsxs(View, {
        "data-selenium-test": Selectors.THANK_YOU.CONTAINER,
        marginBlock: "400",
        as: "div",
        children: [/*#__PURE__*/_jsx("div", {
          className: "heading thank-you-content",
          "data-selenium-test": Selectors.THANK_YOU.HEADER,
          children: /*#__PURE__*/_jsx(NavMarker, {
            name: "thank_you",
            children: heading
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "thank-you-content",
          "data-selenium-test": Selectors.THANK_YOU.BODY,
          dangerouslySetInnerHTML: makeSafeInnerHTML(body)
        }), surveyType === SurveyTypes.CSAT && !hasEmail && gdprSettings && /*#__PURE__*/_jsx(TextInput, {
          "data-selenium-test": Selectors.EMAIL_INPUT,
          onChange: ({
            target: {
              value
            }
          }) => this.setState({
            email: value
          }),
          placeholder: "name@email.com",
          marginBlockEnd: "300"
        }), (surveyType === SurveyTypes.NPS || hasEmail || !gdprSettings) && /*#__PURE__*/_jsx(Link, {
          onClick: onClose,
          "data-selenium-test": Selectors.CLOSE_BUTTON,
          children: closeLabel
        }), surveyType === SurveyTypes.CSAT && !hasEmail && gdprSettings && !shouldShowGDPRConsent && this.renderSubmitButton(submitButtonLabel)]
      })
    });
  }
}
export default ThankYou;